import { memo } from "react"
import styled from "styled-components"
import IconInformativeBlue from "./EvtKit/icons/IconInformativeBlue"
import Caption from "./Typography/Caption"

const ToolTipTitleContainer = styled.div`
  opacity: 1;
  position: absolute;
  transition: opacity 0.3s ease-in-out;
  margin-left: 16px;
`

const ToolTipInformationContainer = styled.div`
  opacity: 0;
  position: absolute;
  transition: opacity 0.3s ease-in-out;
  margin-left: 16px;
`

const ToolTipContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;
  gap: 4px;

  &:hover ${ToolTipTitleContainer} {
    opacity: 0;
  }

  &:hover ${ToolTipInformationContainer} {
    opacity: 1;
  }
`

interface InformationTooltipProps {
  text: string
}

const InformationTooltip = (props: InformationTooltipProps) => {
  const { text } = props

  return (
    <ToolTipContainer>
      <IconInformativeBlue />
      <ToolTipTitleContainer>
        <Caption size="large" weight="light" color="primary-dark">
          Informações
        </Caption>
      </ToolTipTitleContainer>
      <ToolTipInformationContainer>
        <Caption size="large" weight="light" color="primary-dark">
          {text}
        </Caption>
      </ToolTipInformationContainer>
    </ToolTipContainer>
  )
}

export default memo(InformationTooltip)
